import { Shimmer } from '@components';

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 22, width: 22, borderRadius: 4, marginLeft: 8 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

const UpdatesLoading = () => {
  return (
    <div>
      <Shimmer
        style={{ height: 50, width: '100%', borderRadius: 4, marginBottom: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 50, width: '100%', borderRadius: 4, marginBottom: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 50, width: '100%', borderRadius: 4, marginBottom: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </div>
  );
};

export { UpdatesLoading, CountLoading };
